import { PageHero, CTABanner } from "../components/Shared";
import AboutSection from "../sections/AboutSection";
import CommitmentSection from "../sections/CommitmentSection";
import { IMAGES } from "../data/site";

const AboutPage = () => (
  <main data-testid="about-page">
    <PageHero
      eyebrow="About Us"
      title="One of Bangalore's trusted names in printing."
      description="Built through uncompromising quality, timely execution and client-focused service."
      image={IMAGES.operator}
    />
    <AboutSection />
    <CommitmentSection />
    <CTABanner
      title="Work with a team that treats print as a craft."
      text="Tell us about your next project — we will take it from there."
    />
  </main>
);

export default AboutPage;
